import { PathItem } from './types';

const paths: PathItem[] = [
  { key: 'admin-forgot-password', path: 'auth/password/forgot' },
  { key: 'end-user-forgot-password', path: 'admin/ldap/user/end-user-forgot-password' },
  { key: 'end-user-recovery-id', path: 'admin/ldap/user/end-user-recover-userid' },
];

export const getPath = (type: string): string => paths.find(({ key }) => key === type)?.path || '';
